angular.module("exploitation").factory("EitiCompaniesService", ["$http", "ENV", function ($http, ENV) {

	/**
     * API
     */
	return {
		addCompany: addCompany,
		deleteCompany: deleteCompany,
		deleteLine: deleteLine,
		edit: editCompany,
		getCompany: getCompany,
		getAll: getAllCompanies,
		getAllCompaniesByNetworkType: getAllCompaniesByNetworkType,
	};


	/**
     * Récupérer toutes les adminCompanies
     * @returns {*}
     */
	function getAllCompanies(active, useCache) {
		return $http.get(ENV.API_URL + "/companies?active=" + active, {
			cache: useCache ? useCache : false
		});
	}

	/**
	 * Retourne la liste de tous les transporteurs qui ont une ligne du type de réseau
	 * @param active
	 * @param networkType
	 * @param useCache
	 * @returns {HttpPromise}
	 */
	function getAllCompaniesByNetworkType(active, networkType, useCache) {
		return $http.get(ENV.API_URL + "/companies?active=" + active + "&networkType=" + networkType, {
			cache: useCache ? useCache : false
		});
	}

	/**
     * Mettre à jour un adminCompanies.
     * @param company
     * @returns {*|HttpPromise}
     */
	function editCompany(company) {
		return $http.put(ENV.API_URL + "/companies/" + company.id, company);
	}


	/**
     * Récupérer un adminCompanies par son ID.
     *
     * @param id l'Id du company à récupérer.
     * @returns {*}
     */
	function getCompany(id) {
		return $http.get(ENV.API_URL + "/companies/" + id);
	}

	/**
     * Supprimer un company.
     *
     * @param company le company à supprimer.
     * @returns {HttpPromise|*|{display}}
     */
	function deleteCompany(companyId) {
		return $http.delete(ENV.API_URL + "/companies/" + companyId);
	}

	function  deleteLine(lineId){
		return $http.delete(ENV.API_URL + "/lines/" + lineId);
	}


	/**
     * POster un company vers le serveur.
     * @param company
     * @returns {*|HttpPromise}
     */
	function addCompany(company) {
		return $http.post(ENV.API_URL + "/companies", company);
	}


}]);
